import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, useHistory, useLocation } from 'react-router-dom';
import Login from './components/LoginComponent';
import Nodos from './components/NodosComponent';
import VerNodo from './components/VerNodoComponent';
import NuevoNodo from './components/NuevoNodoComponent';
import NuevaArista from './components/NuevaAristaComponent';
import EditarArista from './components/ModificacionArista/EditarAristaComponent';
import Entrenamiento from './components/EntrenamientoComponent';
import NuevoIntent from './components/NuevoIntentComponent';
import EditarIntent from './components/EditarIntentComponent';
import NuevoEntity from './components/NuevoEntityComponent';
import EditarEntity from './components/EditarEntityComponent';
// import Reportes from './components/ReportesComponent';
import Reportes from './components/ReporteriaV2/ReportesComponent';
// import Monitoreo from "./components/MonitoreoComponent";
import Pruebas from './components/Pruebas/PruebasComponent';
import Scripts from './components/ScriptsNoFlujo/ScriptsNoFlujoComponent';
import ModifyScripts from './components/ScriptsNoFlujo/ModifyScriptsNoFlujoComponent';
import ModifyReminders from './components/ScriptsNoFlujo/ModifyRemindersComponent';
import CreateReminders from './components/ScriptsNoFlujo/CreateRemindersComponent';
import Gramaticas from './components/Gramaticas/GramaticasComponent';
import EditGramatica from './components/Gramaticas/EditGramaticaComponent';
import CreateGramatica from './components/Gramaticas/CreateGramaticaComponent';
import ListUsers from './components/Usuarios/UsersComponent';
import NewUser from './components/Usuarios/UsersNewComponent';
import EditUser from './components/Usuarios/UsersEditComponent';
import OwnUser from './components/Usuarios/UsersFrameComponent';
import LogoXira from './components/assets/Logo_Xira.png';
import Notification from './components/NotificationComponent';
import './App.css';
// import logoCliente from './logo-afirme.jpg';
// import logoXira from './logo-xira.jpg';
import {
	login,
	getNodos,
	getIntents,
	getEntities,
	getConversaciones,
	getTemas,
	getGramaticasDebiles,
	getGramaticasFuertes,
	getUsers,
	getUserRoles,
	getArchivos,
	getScriptsNoFlujo,
	getChatbotFunctions,
	getRecordatorios,
} from './routing/routes';
// import * as config from './config'

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: null,
			users: [],
			nodos: [],
			intents: [],
			entities: [],
			gramaticas: {
				fuertes: [],
				debiles: [],
			},
			notification: '',
			reportsData: {
				conversaciones: [],
				noEntendido: [],
				temas: [],
			},
			archivos: {
				imagenes: [],
				audios: [],
				videos: [],
				documentos: [],
			},
			scriptsNoFlujo: [],
			functionesChatbot: [],
			roles: [],
		};

		this.setNotification = this.setNotification.bind(this);
		this.refreshData = this.refreshData.bind(this);
		this.refreshReportsData = this.refreshReportsData.bind(this);
		this.setState = this.setState.bind(this);
		this.setTemas = this.setTemas.bind(this);
		this.signIn = this.signIn.bind(this);
	}

	componentDidMount() {
		this.setState({ user: JSON.parse(sessionStorage.getItem('user')) });
		this.refreshData();
	}

	refreshData() {
		getNodos().then((json) => this.setState({ nodos: json }));
		getUsers().then((json) => this.setState({ users: json }));
		getUserRoles().then((json) => this.setState({ roles: json }));
		getIntents().then((json) => this.setState({ intents: json }));
		getEntities().then((json) => this.setState({ entities: json }));
		getGramaticasFuertes().then((json) => this.setState({ gramaticas: { ...this.state.gramaticas, fuertes: json } }));
		getGramaticasDebiles().then((json) => this.setState({ gramaticas: { ...this.state.gramaticas, debiles: json } }));
		getArchivos().then((json) => this.setState({ archivos: json }));
		getScriptsNoFlujo().then((json) => this.setState({ scriptsNoFlujo: json }));
		getChatbotFunctions().then((json) => this.setState({ functionesChatbot: json }));
		getRecordatorios().then((json) => this.setState({ recordatorios: json }));
	}

	setTemas(data) {
		this.setState({ reportsData: { ...this.state.reportsData, temas: data } });
	}

	async refreshReportsData(fbPage = 'Todas', channel = 'Todos') {
		await Promise.all([
			getConversaciones(fbPage, channel).then((json) => {
				this.setState({
					reportsData: {
						...this.state.reportsData,
						conversaciones: json.conversaciones,
						noEntendido: json.noEntendido,
					},
				});
			}),
			getTemas().then((json) =>
				this.setState({
					reportsData: { ...this.state.reportsData, temas: json },
				})
			),
		]);
		return true;
	}

	setNotification(message) {
		this.setState({ notification: message });
	}

	signIn(user) {
		login(user).then((logged_user) => {
			if (logged_user) {
				sessionStorage.setItem('user', JSON.stringify(logged_user));
			}
			this.setState({ user: logged_user });
		});
	}

	render() {
		const { nodos, intents, entities, notification, scriptsNoFlujo, gramaticas, user, archivos, functionesChatbot, roles, recordatorios } = this.state;
		if (!user) return <Login user={user} login={this.signIn} />;
		return (
			<Router>
				{notification.length > 0 && (
					<Notification message={notification.substring(1, notification.length)} intent={notification[0]} setNotification={this.setNotification} />
				)}
				<nav className='navbar'>
					<Navigation intents={intents} entities={entities} permisos={user.permisos.vistas} />
				</nav>
				<main>
					<Switch>
						{/* SECCION DE LA VISTA DE SCRIPTS */}
						{user.permisos.vistas.scripts && (
							<Route exact path='/scripts'>
								<Scripts
									scriptsNoFlujo={scriptsNoFlujo}
									recordatorios={recordatorios}
									permisos={user.permisos.vistaScripts}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
								/>
							</Route>
						)}

						{user.permisos.vistas.scripts && user.permisos.vistaScripts.modificarScripts && (
							<Route exact path='/scripts/edit/noflujo/:id'>
								<ModifyScripts
									scriptsNoFlujo={scriptsNoFlujo}
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaScripts}
								/>
							</Route>
						)}

						{user.permisos.vistas.scripts && user.permisos.vistaScripts.modificarRecordatorios && (
							<Route exact path='/scripts/edit/recordatorios/:id'>
								<ModifyReminders
									recordatorios={recordatorios}
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									nodos={nodos}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaScripts}
								/>
							</Route>
						)}

						{user.permisos.vistas.scripts && user.permisos.vistaScripts.crearRecordatorios && (
							<Route exact path='/scripts/create/recordatorios/'>
								<CreateReminders
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									nodos={nodos}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaScripts}
								/>
							</Route>
						)}

						{/* SECCION DE LA VISTA DE GRAMATICAS */}
						{user.permisos.vistas.gramaticas && (
							<Route exact path='/gramaticas'>
								<Gramaticas
									gramaticas={gramaticas}
									permisos={user.permisos.vistaGramaticas}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
								/>
							</Route>
						)}

						{user.permisos.vistas.gramaticas && user.permisos.vistaGramaticas.modificarGramaticasDebiles && (
							<Route exact path='/gramaticas/edit/debil/:id'>
								<EditGramatica
									gramaticas={gramaticas}
									nodos={nodos}
									notify={this.setNotification}
									intents={intents}
									entities={entities}
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaGramaticas}
									type='debil'
								/>
							</Route>
						)}

						{user.permisos.vistas.gramaticas && user.permisos.vistaGramaticas.modificarGramaticasFuertes && (
							<Route exact path='/gramaticas/edit/fuerte/:id'>
								<EditGramatica
									gramaticas={gramaticas}
									nodos={nodos}
									notify={this.setNotification}
									intents={intents}
									entities={entities}
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaGramaticas}
									type='fuerte'
								/>
							</Route>
						)}

						{user.permisos.vistas.gramaticas && user.permisos.vistaGramaticas.crearGramaticasDebiles && (
							<Route exact path='/gramaticas/new/debil'>
								<CreateGramatica
									gramaticas={gramaticas}
									nodos={nodos}
									notify={this.setNotification}
									intents={intents}
									entities={entities}
									functionesChatbot={functionesChatbot}
									archivos={archivos}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaGramaticas}
									type='debil'
								/>
							</Route>
						)}

						{user.permisos.vistas.gramaticas && user.permisos.vistaGramaticas.crearGramaticasFuertes && (
							<Route exact path='/gramaticas/new/fuerte'>
								<CreateGramatica
									gramaticas={gramaticas}
									nodos={nodos}
									notify={this.setNotification}
									intents={intents}
									entities={entities}
									functionesChatbot={functionesChatbot}
									archivos={archivos}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaGramaticas}
									type='fuerte'
								/>
							</Route>
						)}

						{/* SECCION DE LA VISTA DE ENTRENAMIENTO */}
						{user.permisos.vistas.entrenamiento && (
							<Route exact path='/training'>
								<Entrenamiento
									intents={intents}
									entities={entities}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaEntrenamiento}
								/>
							</Route>
						)}

						{user.permisos.vistas.entrenamiento && user.permisos.vistaEntrenamiento.crearIntenciones && (
							<Route exact path='/intents/new'>
								<NuevoIntent
									intents={intents}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaEntrenamiento}
								/>
							</Route>
						)}

						{user.permisos.vistas.entrenamiento && user.permisos.vistaEntrenamiento.modificarIntenciones && (
							<Route exact path='/intents/edit/:id'>
								<EditarIntent
									intents={intents}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaEntrenamiento}
								/>
							</Route>
						)}

						{user.permisos.vistas.entrenamiento && user.permisos.vistaEntrenamiento.crearEntidades && (
							<Route exact path='/entities/new'>
								<NuevoEntity
									entities={entities}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaEntrenamiento}
								/>
							</Route>
						)}

						{user.permisos.vistas.entrenamiento && user.permisos.vistaEntrenamiento.modificarEntidades && (
							<Route exact path='/entities/edit/:id'>
								<EditarEntity
									entities={entities}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaEntrenamiento}
								/>
							</Route>
						)}

						{/* SECCION DE LA VISTA DE LOS REPORTES */}
						{user.permisos.vistas.reporteria && (
							<Route exact path='/reports'>
								<Reportes permisos={user.permisos.vistaReporteria} />
							</Route>
						)}

						{/* SECCION DE LA VISTA DE PRUEBAS */}
						{user.permisos.vistas.pruebas && (
							<Route exact path='/pruebas'>
								<Pruebas setNotification={this.setNotification} permisos={user.permisos.vistaPruebas} />
							</Route>
						)}

						{/* SECCION DE LA VISTA DE USUARIOS */}
						{user.permisos.vistas.usuarios && (
							<Route exact path='/users'>
								<ListUsers
									users={this.state.users}
									user={this.state.user}
									permisos={user.permisos.vistaUsuarios}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
								/>
							</Route>
						)}

						{user.permisos.vistas.usuarios && user.permisos.vistaUsuarios.crearUsuarios && (
							<Route exact path='/users/new'>
								<NewUser
									refreshData={this.refreshData}
									users={this.state.users}
									permisos={user.permisos.vistaUsuarios}
									roles={roles}
									setNotification={this.setNotification}
								/>
							</Route>
						)}

						{user.permisos.vistas.usuarios && (
							<Route exact path={`/users/edit/${this.state.user._id}`}>
								<OwnUser
									refreshData={this.refreshData}
									user={this.state.user}
									roles={roles}
									setNotification={this.setNotification}
									permisos={user.permisos.vistaUsuarios}
								/>
							</Route>
						)}

						{user.permisos.vistas.usuarios && user.permisos.vistaUsuarios.modificarUsuarios && (
							<Route exact path='/users/edit/:id'>
								<EditUser
									refreshData={this.refreshData}
									users={this.state.users}
									permisos={user.permisos.vistaUsuarios}
									roles={roles}
									setNotification={this.setNotification}
								/>
							</Route>
						)}

						{/* SECCION DE LA VISTA DE MANEJO DE NODOS */}

						{user.permisos.vistas.manejoNodos && user.permisos.vistaMDN.crearNodo && (
							<Route exact path='/new'>
								<NuevoNodo nodos={nodos} setNotification={this.setNotification} refreshData={this.refreshData} permisos={user.permisos.vistaMDN} />
							</Route>
						)}

						{user.permisos.vistas.manejoNodos && user.permisos.vistaMDN.modificarNodo && (
							<Route exact path='/edit/:id'>
								<VerNodo
									nodos={nodos}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									functionesChatbot={functionesChatbot}
									permisos={user.permisos.vistaMDN}
								/>
							</Route>
						)}

						{user.permisos.vistas.manejoNodos && user.permisos.vistaMDN.crearArista && (
							<Route exact path='/new_connection/:id'>
								<NuevaArista
									nodos={nodos}
									intents={intents}
									entities={entities}
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaMDN}
								/>
							</Route>
						)}

						{user.permisos.vistas.manejoNodos && user.permisos.vistaMDN.modificarAristas && (
							<Route exact path='/edit_connection/:id/:index'>
								<EditarArista
									nodos={nodos}
									intents={intents}
									entities={entities}
									archivos={archivos}
									functionesChatbot={functionesChatbot}
									setNotification={this.setNotification}
									refreshData={this.refreshData}
									permisos={user.permisos.vistaMDN}
								/>
							</Route>
						)}

						{user.permisos.vistas.manejoNodos && (
							<Route path='/'>
								<Nodos nodos={nodos} permisos={user.permisos.vistaMDN} />
							</Route>
						)}
					</Switch>
					<div style={{ marginTop: 40 }}></div>
				</main>
			</Router>
		);
	}
}

const Navigation = ({ intents, entities, permisos }) => {
	const history = useHistory();
	const location = useLocation();
	const [activeRoute, setActiveRoute] = useState(0);
	const [allTrained, setAllTrained] = useState(false);

	useEffect(() => {
		if (intents.length > 0 && entities.length > 0) {
			if (
				intents.some((e) => {
					const result = e.examples.some((e2) => {
						const result2 = e2.trained === false;
						return result2;
					});
					return result;
				}) ||
				entities.some((e) => {
					const result = e.subentities.some((e2) => {
						const result2 = e2.examples.some((e3) => {
							const result3 = e3.trained === false;
							return result3;
						});
						return result2;
					});
					return result;
				})
			) {
				setAllTrained(false);
			} else {
				setAllTrained(true);
			}
		} else {
			setAllTrained(false);
		}
	}, [intents, entities]);

	useEffect(() => {
		if (location.pathname.includes('/scripts')) {
			permisos.scripts && setActiveRoute(1);
		} else if (location.pathname.includes('/gramaticas')) {
			permisos.gramaticas && setActiveRoute(2);
		} else if (location.pathname.includes('/training')) {
			permisos.entrenamiento && setActiveRoute(3);
		} else if (location.pathname.includes('/reports')) {
			permisos.reporteria && setActiveRoute(4);
		} else if (location.pathname.includes('/pruebas')) {
			permisos.pruebas && setActiveRoute(5);
		} else if (location.pathname.includes('/users')) {
			permisos.usuarios && setActiveRoute(6);
		} else {
			permisos.manejoNodos && setActiveRoute(0);
		}
	}, [permisos, location.pathname]);

	return (
		<ul className='navbar-nav'>
			<img src={LogoXira} className='LogoXira' alt='Logo_Xira' />
			{permisos.manejoNodos && (
				<li
					className='navbar-link'
					onClick={() => {
						setActiveRoute(0);
						history.push('/');
					}}
					style={{
						opacity: activeRoute === 0 ? 1 : 0.5,
						fontWeight: activeRoute === 0 ? 'bold' : 'normal',
					}}
				>
					Manejo de Nodos
				</li>
			)}
			{permisos.scripts && (
				<li
					className='navbar-link'
					onClick={() => {
						setActiveRoute(1);
						history.push('/scripts');
					}}
					style={{
						opacity: activeRoute === 1 ? 1 : 0.5,
						fontWeight: activeRoute === 1 ? 'bold' : 'normal',
					}}
				>
					Scripts
				</li>
			)}
			{permisos.gramaticas && (
				<li
					className='navbar-link'
					onClick={() => {
						setActiveRoute(2);
						history.push('/gramaticas');
					}}
					style={{
						opacity: activeRoute === 2 ? 1 : 0.5,
						fontWeight: activeRoute === 2 ? 'bold' : 'normal',
					}}
				>
					Gramáticas
				</li>
			)}
			{permisos.entrenamiento && (
				<li
					className={allTrained ? 'navbar-link' : 'navbar-link blink_me'}
					onClick={() => {
						setActiveRoute(3);
						history.push('/training');
					}}
					style={{
						opacity: activeRoute === 3 ? 1 : 0.5,
						fontWeight: activeRoute === 3 ? 'bold' : 'normal',
					}}
				>
					Entrenamiento
				</li>
			)}
			{permisos.reporteria && (
				<li
					className='navbar-link'
					onClick={() => {
						setActiveRoute(4);
						history.push('/reports');
					}}
					style={{
						opacity: activeRoute === 4 ? 1 : 0.5,
						fontWeight: activeRoute === 4 ? 'bold' : 'normal',
					}}
				>
					Reportería
				</li>
			)}
			{permisos.pruebas && (
				<li
					className='navbar-link'
					onClick={() => {
						setActiveRoute(5);
						history.push('/pruebas');
					}}
					style={{
						opacity: activeRoute === 5 ? 1 : 0.5,
						fontWeight: activeRoute === 5 ? 'bold' : 'normal',
					}}
				>
					Pruebas
				</li>
			)}
			{permisos.usuarios && (
				<li
					className='navbar-link'
					onClick={() => {
						setActiveRoute(6);
						history.push('/users');
					}}
					style={{
						opacity: activeRoute === 6 ? 1 : 0.5,
						fontWeight: activeRoute === 6 ? 'bold' : 'normal',
					}}
				>
					Usuarios
				</li>
			)}
			<li
				className='navbar-link'
				onClick={() => {
					sessionStorage.clear();
					window.location.reload();
					history.push('/');
				}}
			>
				Logout
			</li>
		</ul>
	);
};

export default App;

// administrador: {
// 	vistas: {
// 		manejoNodos: true,
// 		scripts: true,
// 		gramaticas: true,
// 		entrenamiento: true,
// 		usuarios: true,
// 		pruebas: true,
// 		reporteria: true,
// 	},
// 	vistaMDN: {
// 		modificarNodo: true,
// 		crearNodo: true,
// 		eliminarNodo: true,
// 		modificarAristas: true,
// 		crearArista: true,
// 		eliminarArista: true,
// 	},
// 	vistaScripts: {
// 		modificarScripts: true,
// 	},
// 	vistaGramaticas: {
// 		crearGramaticasDebiles: true,
// 		modificarGramaticasDebiles: true,
// 		eliminarGramaticasDebiles: true,
// 		crearGramaticasFuertes: true,
// 		modificarGramaticasFuertes: true,
// 		eliminarGramaticaFuertes: true,
// 	},
// 	vistaEntrenamiento: {
// 		crearEntidades: true,
// 		modificarEntidades: true,
// 		eliminarEntidades: true,
// 		crearIntenciones: true,
// 		modificarIntenciones: true,
// 		eliminarIntenciones: true,
// 		entrenar: true,
// 	},
// 	vistaReporteria: {
// 		descargarReportes: true,
// 	},
// 	vistaPruebas: {
// 		analizarExpresion: true,
// 	},
// 	vistaUsuarios: {
// 		crearUsuarios: false,
// 		modificarUsuarios: true,
// 		eliminarUsuarios: true,
// 	},
// },
